import React from 'react'

import { CalendarIcon } from '~/assets/icons'
import UspBadge from '~/components/usp-badge'

import styles from './styles.module.css'

const CoolingOffPeriod = ({ isHomepage = false }: { isHomepage?: boolean }) => (
  <>
    <div className={styles.badgeContainer} data-is-homepage={isHomepage}>
      <UspBadge
        className={styles.badge}
        icon={<CalendarIcon />}
        text='14-day cooling off period'
        variant='blue-primary'
      />
    </div>

    <p className={styles.footerText} data-is-homepage={isHomepage}>
      You always have a 14-day ‘cooling off’ period, during which you can cancel your request to switch broadband
      provider – free of charge.
    </p>
  </>
)

export default CoolingOffPeriod
